<template>
  <page-error :is-mobile="isMobile" :showHeader="!!user.uid">
    <template #title>
      {{ $t('CP.notFound404') }}
    </template>
    <template #message>
      {{ $t('CP.unfortunately404') }}<br>
      {{ $t('CP.tryContact') }}
      <a :href="`mailto:${basicInfo.supportServiceEmail}`">
        {{ $t('CP.supportService') }}
      </a>
    </template>
  </page-error>
</template>

<script>
import PageError from '../layouts/PageError/PageError';

export default {
  name: 'Page404',
  components: {
    PageError,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    basicInfo() {
      return this.$store.getters.basicInfo;
    },
    user() {
      return this.$store.getters.getProfile;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
